<template>
    <div class="md-layout myData_table">
        <div class="md-layout-item md-size-100">
            <table-card class="m-0">
                <template slot="content">
                    <div class="md-layout">
                         <div v-if="!isMyDataRoute"><p style="font-size: 20px; color: black;">To add inputs please go to <a :href="myDataPath" class="hover dark-blue-color"  target="_blank">SAVED INPUTS</a>, then return to this page and refresh.</p></div>


                         <div v-else>
                            <p style="font-size: 20px; color: black;">Use this tool to add inputs via CSV or Built in Form, which can then be applied to any Bizminer Report.  Label your inputs with a data source and a brief description, such as company name.</p>
                         </div>

                        <div v-if="isThereMyData" class="md-layout-item md-size-100 p-0">
                            <md-table v-model="tableData" table-header-color="white" class="billing-and-invoices-table">
                                <md-table-row slot="md-table-row" slot-scope="{ item }">
                                    <md-table-cell md-label="Date Created">
                                       <div class="black-color">{{
                                                item.dateCreated
                                        }}</div>
                                    </md-table-cell>
                                    <md-table-cell md-label="Date Modified">
                                        <div class="black-color">{{
                                                item.dateModified
                                        }}</div>
                                    </md-table-cell>
                                    <md-table-cell md-label="Data Source">
                                        <div class="black-color">{{
                                                item.dataSource
                                        }}</div>
                                    </md-table-cell>
                                    <md-table-cell md-label="Description">
                                        <div class="black-color">{{
                                                item.description
                                        }}</div>
                                    </md-table-cell>
                                    <md-table-cell :md-label="!isMyDataRoute ? 'Add' : 'Manage'">
                                        <button v-if="isMyDataRoute" @click="openDeleteConfirmationModal(item)"
                                            type="button"
                                            class="border-0 md-danger table-action-button md-theme-default">
                                            <md-icon>delete_forever</md-icon>
                                        </button>
                                        <router-link v-if="isMyDataRoute"
                                            :to="{ name: 'EditMyData', params: { id: item.id }, props: { isReport: 'testeteste' } }"
                                            class="ml-5">
                                            <button type="button"
                                                class="border-0 md-primary table-action-button md-theme-default">
                                                <md-icon>settings</md-icon>
                                            </button>
                                        </router-link>
                                        <button v-if="!isMyDataRoute" @click="selectDataSource(item)" type="button"
                                            class="border-0 md-danger table-action-button md-theme-default">
                                            <md-icon>add_circle</md-icon>
                                        </button>
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                        </div>
                        


                        
                        
                    </div>
                </template>
            </table-card>
        </div>
        <div class="prospect_content">
            <modal v-if="confirmationModal" @close="confirmationModal = false">
                <template slot="header">
                    <button type="button" class="close_btn" @click="confirmationModal = false">
                        <md-icon>clear</md-icon>
                    </button>
                </template>
                <template slot="body">
                    <h3 class="modal-title">
                        Are you sure to delete this item?

                    </h3>
                    <h4 class="modal-title">
                        Description: {{ currentItemDescription }}
                    </h4>
                    <div class="field_wpr">

                        <div class="ml-4 md-layout">
                            <md-button @click="confirmationModal = false"
                                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">Cancel</md-button>
                            <md-button @click="deleteMyData"
                                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">Yes
                            </md-button>
                        </div>
                    </div>
                </template>
            </modal>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { Modal, TableCard } from '@/components';

export default {
    name: 'my-data-table',
    components: {
        TableCard,
        Modal,
    },
    data() {
        return {
            tableData: [],
            newInputsModal: false,
            newInputType: 'simple',
            newInputStep: 1,
            inputDescription: '',
            inputDataSource: '',
            currentItemId: null,
            currentItemDescription: null,
            confirmationModal: false,
            isMyDataRoute: false,
            isThereMyData: false,
            myDataPath: `${window.location.origin+'/my-data'}`,
        };
    },
    computed: {
        ...mapState({
            auth_user: (state) => state.user,
            defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
            isRetail: (state) => (state.user.user_type.retail/* || state.user.allow_retail*/) ?true: null,
        }),
    },
    methods: {
        selectDataSource: async function (item) {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            let myDataId = item.id;
            this.loaded = false;

            let params = {
                session_id: currentSession,
                my_data_id: myDataId,
            };

            await this.$store.dispatch('myData/get', params).then(res => {
                this.myData = res.data.my_data;
                this.years = res.data.years;
                this.$store.commit('SET_MY_DATA_SELECTED_REPORT', {
                    years: res.data.years,
                    myData: res.data.my_data
                });
                this.loaded = true;
            });
        },

        checkRoute() {
            if (this.$route.name === 'MyData')
                this.isMyDataRoute = true;
            else
                this.isMyDataRoute = false;
        },
        openDeleteConfirmationModal: function (item) {
            this.currentItemId = item.id;
            this.currentItemDescription = item.description;
            this.confirmationModal = true;
        },
        deleteMyData: async function () {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );

            let params = {
                session_id: currentSession,
                my_data_id: this.currentItemId,
            };

            await this.$store.dispatch('myData/destroy', params).then((res) => {
                this.$store.dispatch('alerts/success', 'Data deleted.');
                this.getAllMyData();
            });
            this.confirmationModal = false;
        },
        sendDataFatherComponent: function (isLoadingAux) {
            this.$emit('get-load', { isLoading: isLoadingAux})
        },
        getAllMyData: async function () {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            this.loaded = false;
            this.sendDataFatherComponent(true)
            let params = {
                session_id: currentSession,
            };

            await this.$store.dispatch('myData/list', params).then((res) => {
                let myData = res;
                this.parseTableData(myData);

                this.loaded = true;

                if(myData.data.my_data.length>0)
                  this.isThereMyData = true;

                this.sendDataFatherComponent(false)
            });
        },
        parseTableData: async function (myData) {
            this.tableData = [];

            myData.data.my_data.forEach((data) => {
                this.tableData.push({
                    dateCreated: moment(data.dateCreated).format('YYYY-MM-DD'),
                    dateModified: moment(data.dateUpdated).format('YYYY-MM-DD'),
                    dataSource: data.dataSource,
                    description: data.description,
                    inputsType: data.type,
                    products: '',
                    id: data.id,
                });
            });

            if (this.isRetail) {
                this.tableData.splice(1, this.tableData.length);
            }

            this.tableData = this.tableData.sort(function (a, b) {
                return new Date(b.id) - new Date(a.id);
            });
        },
    },
    async created() {
        this.checkRoute();
        await this.getAllMyData();
    },
};
</script>
<style lang="scss">
.search-box input,
.client-name-box input,
.client-name-box textarea {
    width: 100%;
}

.client-name-box>div {
    width: 100%;
}

.myData_table .md-card-content .md-table table th {
    background-color: #002277 !important;
}
 
</style>
